"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.starts-with");
var _gift_card = require("@/api/community/gift_card.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GiftCardUploadPane',
  props: {
    coverImageUrl: {
      type: String,
      default: ''
    },
    imgAccessDomain: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      imageUrl: null,
      uploading: false
    };
  },
  created: function created() {
    if (this.coverImageUrl) {
      this.imageUrl = this.imgAccessDomain + this.coverImageUrl;
    }
  },
  methods: {
    handleImageClick: function handleImageClick() {
      this.$refs.fileInput.click();
    },
    handleFileChange: function handleFileChange(event) {
      var files = event.target.files;
      if (files.length === 0) return;
      var file = files[0];
      if (this.validateImage(file)) {
        this.uploadImage(file);
      }
      event.target.value = '';
    },
    validateImage: function validateImage(file) {
      var isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var response, data;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.uploading = true;
              _context.prev = 1;
              _context.next = 2;
              return (0, _gift_card.uploadGiftCardImage)(file);
            case 2:
              response = _context.sent;
              if (response.code === 200) {
                data = response.data;
                this.imageUrl = this.imgAccessDomain + data.pathKey;
                this.$emit('uploadSuccess', data.pathKey);
                this.$message.success('图片上传成功!');
              }
            case 3:
              _context.prev = 3;
              this.uploading = false;
              return _context.finish(3);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function uploadImage(_x) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }()
  }
};